import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { getOperationDashboardCount } from "../../../Redux/action/Admin/OperationsDashboardAction";
import "./OperationsDashboard.css";

// ─── Data ───────────────────────────────────────────────────────────────────
import {
  kpiCards,
  operationsGlance,
  customsClearance,
} from "./dashboardData";

// ─── Components ─────────────────────────────────────────────────────────────
import KpiCard from "./KpiCard";
import QuotationOverviewCard from "./QuotationOverviewCard";
import JobOrderStatusCard from "./JobOrderStatusCard";
import StatusList from "./StatusList";
import MilestoneTimeline from "./MilestoneTimeline";
import ActionRequired from "./ActionRequired";
import TodaysOperations from "./TodaysOperations";
import ActivityList from "./ActivityList";

/**
 * OperationsDashboard
 * Main content area for the Flexichain Logistics ERP – Operations view.
 * Assumes navbar/sidebar are rendered by parent layout.
 */
const OperationsDashboard = ({ user_id: propUserId }) => {
  const dispatch = useDispatch();
  const user_id = propUserId || Cookies.get("flexichain_user_id");
  const token = Cookies.get("token");

  useEffect(() => {
    dispatch(getOperationDashboardCount(token, user_id));
  }, [dispatch, token, user_id]);

  const {
    loadingOperationDashboardCount,
    operationDashboardCount,
    operationDashboardCountError,
  } = useSelector((state) => state?.OperationsDashboardReducer || {});

  // Compute dynamic KPI cards using API response
  const dynamicKpiCards = useMemo(() => {
    return kpiCards.map((card) => {
      let updatedValue = card.value;

      if (operationDashboardCount) {
        if (card.id === "open-quotations" && operationDashboardCount.openQuotations !== undefined) {
          updatedValue = operationDashboardCount.openQuotations;
        } else if (card.id === "jobs-in-progress" && operationDashboardCount.jobsInProgress !== undefined) {
          updatedValue = operationDashboardCount.jobsInProgress;
        } else if (card.id === "active-freight" && operationDashboardCount.activeFreightForwarding !== undefined) {
          updatedValue = operationDashboardCount.activeFreightForwarding;
        } else if (card.id === "due-today" && operationDashboardCount.dueToday !== undefined) {
          updatedValue = operationDashboardCount.dueToday;
        } else if (card.id === "jobs-closed-today" && operationDashboardCount.jobsClosedToday !== undefined) {
          updatedValue = operationDashboardCount.jobsClosedToday;
        }
      }

      return {
        ...card,
        value: updatedValue,
        loading: loadingOperationDashboardCount,
      };
    });
  }, [operationDashboardCount, loadingOperationDashboardCount]);

  return (
    <div className="page-wrapper ops-page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-8">
                  <h4 className="page-title">Operations Dashboard</h4>
                  <p className="ops-page-subtitle">
                    Monitor and manage your logistics operations in real time
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ops-dashboard">
          {/* ── Row 1: KPI Cards ───────────────────────────────────────── */}
          <div className="ops-kpi-row">
            {dynamicKpiCards.map((card) => (
              <KpiCard key={card.id} {...card} />
            ))}
          </div>

          {/* ── Row 2: Middle Section ──────────────────────────────────── */}
          <div className="ops-middle-grid">
            <QuotationOverviewCard />
            <JobOrderStatusCard />
            <StatusList title="Operations at a Glance" items={operationsGlance} headingIcon="truck" />
            <StatusList title="Customs Clearance" items={customsClearance} headingIcon="customs" />
          </div>

          {/* ── Row 3: Milestone Timeline ──────────────────────────────── */}
          {/* <div style={{ marginBottom: 16 }}>
            <MilestoneTimeline />
          </div> */}

          {/* ── Row 4: Bottom Section ──────────────────────────────────── */}
          <div className="ops-bottom-grid">
            <ActionRequired />
            <TodaysOperations counts={operationDashboardCount} />
            <ActivityList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationsDashboard;
